import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { formValueSelector, change, Field } from 'redux-form'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import { DayField, MonthField, YearField } from 'components/forms'
import styles from './_birthdateField.css'
import classnames from 'classnames'
import FieldError from 'components/forms/FieldError'

const mapStateToProps = (state, props) => {
  const valueSelector = formValueSelector(props.formName)
  return {
    day: valueSelector(state, 'day'),
    month: valueSelector(state, 'month'),
    year: valueSelector(state, 'year'),
  }
}

const mapDispatchToActions = {
  change,
}

export class BirthdateField extends Component {

  static propTypes = {
    name: PropTypes.string,
    disabled: PropTypes.bool,
    slim: PropTypes.bool,
    day: PropTypes.string,
    month: PropTypes.string,
    year: PropTypes.string,
    change: PropTypes.func,
    formName: PropTypes.string,
    meta: PropTypes.object,
    className: PropTypes.string,
  }

  componentDidMount () {
    this.updateBirthdate(this.props)
  }

  componentWillReceiveProps (nextProps) {
    this.updateBirthdate(nextProps)
  }

  updateBirthdate = ({ day, month, year }) => {
    const { formName, name } = this.props
    this.props.change(formName, name, `${year}-${month}-${day}`)
  }

  render () {
    const today = new Date()
    const { disabled, slim } = this.props
    const {
      meta: {
        error,
        touched,
      },
    } = this.props
    const showError = Boolean(touched && error)

    const className = classnames(styles.container, this.props.className, {
      [styles.disabled]: disabled,
      [styles.slim]: slim,
    })

    return (
      <div className={className}>
        <div className={styles.inner}>

          <DayField
            slim={slim}
            name='day'
            hideError={true}
            disabled={disabled}
            labelComponent={null}
            errorComponent={null}
          />

          <MonthField
            slim={slim}
            name='month'
            hideError={true}
            disabled={disabled}
            labelComponent={null}
            errorComponent={null}
          />

          <YearField
            slim={slim}
            sort='dec'
            name='year'
            hideError={true}
            disabled={disabled}
            from={today.getFullYear() - 120}
            to={today.getFullYear() - 11}
            labelComponent={null}
            errorComponent={null}
          />

        </div>

        <FieldError
          showError={showError}
          errorMessage={error}
          errorComponent={(
            <FormattedMessage
              id='forms.birthdate_field.required'
              defaultMessage='Birthdate required'
            />
          )}
        />

      </div>
    )
  }
}

export const ConnectedBirthdateField = connect(mapStateToProps, mapDispatchToActions)(BirthdateField)
export const renderField = (field) => <ConnectedBirthdateField {...field} />
export const FieldWrapper = (props) => <Field {...props} component={renderField} />

export default FieldWrapper



// WEBPACK FOOTER //
// ./src/components/forms/BirthdateField/BirthdateField.jsx